import React from 'react';
import * as s from './styled-empty-state';

// Icone default (lucide:search-x) — o caso mais comum e "filtros sem
// resultado". Telas podem sobrescrever via prop `icon`.
const DefaultIcon = (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="m13.5 8.5-5 5M8.5 8.5l5 5" />
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </svg>
);

// actionLabel + onAction: atalho pro botao ghost padrao (ex.: "Limpar
// filtros") sem cada tela precisar estilizar o proprio botao. A prop
// `action` (node) continua aceita pra casos custom.
const EmptyState = ({
  icon = DefaultIcon,
  title,
  description,
  action,
  actionLabel,
  onAction,
}) => (
  <s.Container role="status">
    {icon && <s.IconSlot>{icon}</s.IconSlot>}
    {title && <s.Title>{title}</s.Title>}
    {description && <s.Description>{description}</s.Description>}
    {action && <s.Action>{action}</s.Action>}
    {!action && actionLabel && onAction && (
      <s.Action>
        <s.ActionButton type="button" onClick={onAction}>
          {actionLabel}
        </s.ActionButton>
      </s.Action>
    )}
  </s.Container>
);

export default EmptyState;
